$(() => {
    // bootstrap form validation styling
    $('form.EPiServerForms.needs-validation').submit((event) => {
        const $form = $(event.target);
        if ($form.get(0).checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            updateAriaAttributes();
            focusFirstInvalidInput();
        }
        $form.addClass('was-validated');
    });

    // Update validation set by server
    $('.form-control.is-invalid, .form-control.is-valid').on('input', (event) =>
        event.target.checkValidity() ? validate($(event.target)) : inValidate($(event.target))
    );

    const updateAriaAttributes = () => {
        $(':invalid').each((_, elm) => {
            elm.setAttribute('aria-describedby', `invalid-${elm.id}`);
            elm.setAttribute('aria-invalid', `true`);
        });
    };

    const focusFirstInvalidInput = () => {
        $('input:invalid, textarea:invalid, select:invalid').first().focus();
    };

    const validate = ($control) =>
        $control
            .addClass('is-valid')
            .removeClass('is-invalid')
            .attr('aria-describedby', `valid-${$control.attr('id')}`)
            .attr('aria-invalid', 'false');

    const inValidate = ($control) =>
        $control
            .addClass('is-invalid')
            .removeClass('is-valid')
            .attr('aria-describedby', `invalid-${$control.attr('id')}`)
            .attr('aria-invalid', 'true');

    const $listOfMultipleSelects = document.querySelectorAll('[data-multiple-select-input]');

    if ($listOfMultipleSelects) {
        const closeAllMultipleSelect = function () {
            document
                .querySelectorAll('[data-multiple-select-input]')
                .forEach((multipleSelectRef) => {
                    multipleSelectRef
                        .querySelector('[data-multiple-select-input--list]')
                        .classList.add('d-none');
                });
        };
        document.addEventListener('click', (e) => {
            if (
                !e.target.classList.contains('[data-multiple-select-input]') &&
                !e.target.closest('[data-multiple-select-input]')
            ) {
                closeAllMultipleSelect();
            }
        });

        $('body').on('keyup', '[data-multiple-select-input]', (e) => {
            if (e.which === 27) {
                closeAllMultipleSelect();
            }
        });

        $('body').on('click', '[data-multiple-select-input--toggle]', (e) => {
            e.stopPropagation();
            var multipleSelect = e.target.closest('[data-multiple-select-input]');

            const selectList = multipleSelect.querySelector('[data-multiple-select-input--list]');
            if (selectList.classList.contains('d-none')) {
                closeAllMultipleSelect();
                selectList.classList.remove('d-none');
            } else {
                selectList.classList.add('d-none');
            }
        });
    }
});
